export const DEFAULT_HINT_DELAYS_SEC = [300, 180, 240, 300, 300];
export const HINT_DELAY_STORAGE_KEY = "hintDelaysSec";
export const HINT_DELAY_EVENT = "hintDelaysUpdated";

export const loadHintDelaysSec = () => {
  if (typeof localStorage === "undefined") return DEFAULT_HINT_DELAYS_SEC;
  try {
    const raw = localStorage.getItem(HINT_DELAY_STORAGE_KEY);
    if (!raw) return DEFAULT_HINT_DELAYS_SEC;
    const parsed = JSON.parse(raw);
    if (
      Array.isArray(parsed) &&
      parsed.length === DEFAULT_HINT_DELAYS_SEC.length &&
      parsed.every((value) => Number.isFinite(value) && value >= 0)
    ) {
      return parsed;
    }
    return DEFAULT_HINT_DELAYS_SEC;
  } catch (error) {
    console.error("Failed to load hint timing", error);
    return DEFAULT_HINT_DELAYS_SEC;
  }
};

export const normalizeHintDelayMinutes = (minutes) => {
  const normalized = Array.isArray(minutes) ? minutes : [];
  return DEFAULT_HINT_DELAYS_SEC.map((fallback, index) => {
    const value = Number(normalized[index]);
    if (!Number.isFinite(value)) return fallback;
    return Math.max(0, value * 60);
  });
};

export const saveHintDelaysSec = (nextSeconds) => {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(HINT_DELAY_STORAGE_KEY, JSON.stringify(nextSeconds));
  } catch (error) {
    console.error("Failed to save hint timing", error);
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(HINT_DELAY_EVENT));
  }
};
